import { combineReducers } from 'redux';
import { ShopViewModel } from 'stageclip-common';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ById } from '../store/normalizedState';

import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.AllShopsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.ShopCreated:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.ActiveClientsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.ClientCreated:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.ActiveEventsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.EventLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.shops);
    default:
      return state;
  }
}

function byIdReducer(state: ById<ShopViewModel> = {}, action: AllActions): ById<ShopViewModel> {
  switch (action.type) {
    case InternalActionTypes.AllShopsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.ShopCreated:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.ActiveClientsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.ClientCreated:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.ActiveEventsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.EventLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.shops);
    default:
      return state;
  }
}

export const shopsReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
